const setSessionStorage = <T>(key: string, value: T): void => {
  sessionStorage.setItem(key, JSON.stringify(value))
}

const getSessionStorage = <T>(key: string): T | null => {
  const item = sessionStorage.getItem(key)
  return item ? (JSON.parse(item) as T) : null
}

const removeSessionStorage = (key: string): void => {
  sessionStorage.removeItem(key)
}

const clearSessionStorage = (): void => {
  sessionStorage.clear()
}

export { setSessionStorage, getSessionStorage, removeSessionStorage, clearSessionStorage }
